import React from "react";
import { makeStyles, withStyles } from "@material-ui/styles";
import { Link } from "react-router-dom";
import Paper from "@material-ui/core/Paper";
import InputBase from "@material-ui/core/InputBase";
import Divider from "@material-ui/core/Divider";
import IconButton from "@material-ui/core/IconButton";
import SearchIcon from "@material-ui/icons/Search";

import PlacesAuto from "./PlacesAuto";

const useStyles = makeStyles((theme) => ({
  root: {
    padding: "2px 4px",
    display: "flex",
    alignItems: "center",
    width: "100%",
    [theme.breakpoints.up("md")]: {
      width: 400,
    },
  },
  iconButton: {
    padding: 10,
  },
  divider: {
    height: 28,
    margin: 4,
  },
  auto: {
    maxWidth: "100%",
    flex: 1,
  },
  dialog: {
    minHeight: 300,
    minWidth: 300,
  },
}));

export default function SearchMobile({ refine, value, setValue }) {
  const classes = useStyles();
  let onSubmit = async (e) => {
    e.preventDefault();
  };

  return (
    <Paper component="form" className={classes.root} onSubmit={onSubmit}>
      <IconButton
        type="submit"
        className={classes.iconButton}
        aria-label="search"
      >
        <SearchIcon />
      </IconButton>
      <PlacesAuto
        className={classes.auto}
        refine={refine}
        value={value}
        setValue={setValue}
      >
        <InputBase
          fullWidth
          className={classes.input}
          placeholder="Address, City, Zip"
        />
      </PlacesAuto>
      <Divider className={classes.divider} orientation="vertical" />
    </Paper>
  );
}
